import styled from "styled-components";
import { RollFromBottom } from "../ui/animations";

const Flex = styled.div`
  display: flex;
  flex-direction: ${({ column }) => (column ? "column" : "row")};
  align-items: ${({ alignItems }) => alignItems};
  justify-content: ${({ justifyContent }) => justifyContent};
  height: ${({ fillHeight }) => (fillHeight ? "100%" : "auto")};
  width: ${({ width }) => (width ? width : "100%")};
  .Burger {
    z-index: 50;
    position: fixed;
    top: calc(5rem - 17px);
    right: 8.6%;
    @media (max-width: 600px) {
      top: calc(3rem - 17px);
    }
  }
  .BurgerInner,
  .BurgerInner:after,
  .BurgerInner:before {
    z-index: 11;
    background: #fff;
    height: 3px;
    color: white;
  }
  .BurgerInner:before {
    width: 50%;
    margin-left: 50%;
  }
  .BurgerInner:after {
    display: ${props => (props.burger ? "block" : "none")};
    width: 98%;
  }
  .BurgerBox {
    margin-right: -14px;
    margin-bottom: 40px;
  }
`;

export default Flex;
